import { IAIWorkspace } from "@entities/aiWorkspace/lib/types";
import { useRef, useState } from "react";
import { scriptGenerationHeld } from "./ScriptGenerationTab/finishedScript";
import { ScriptGenerationTab } from "./ScriptGenerationTab";
import styles from "./styles.module.scss";

export function ScriptGenerationPane({
  active,
  workspace,
  requestId,
  jobId,
  onOpenRequest,
  onSelectCreatorJob,
}: {
  active: boolean;
  workspace: IAIWorkspace;
  requestId: string;
  jobId: string;
  onOpenRequest?: (id: string, type: string) => void;
  onSelectCreatorJob?: (jobId: string) => void;
}) {
  const held = useRef({ requestId: "", jobId: "" });
  const [generating, setGenerating] = useState(false);
  if (active && (requestId || jobId)) {
    held.current = { requestId, jobId };
  }
  const restoreHeld = !active || (generating && !requestId && !jobId);
  const paneRequestId = restoreHeld ? held.current.requestId : requestId;
  const paneJobId = restoreHeld ? held.current.jobId : jobId;

  if (!active && !generating && !scriptGenerationHeld()) return null;

  return (
    <div className={active ? "animate-in fade-in duration-200" : styles.parkedPane}>
      <header className={styles.header}>
        <p className={styles.headerSubtitle}>Script Generation</p>
      </header>
      <ScriptGenerationTab
        key={paneRequestId || "script-generation"}
        workspace={workspace}
        requestId={paneRequestId}
        creatorScriptGeneratorJobId={paneJobId}
        onOpenRequest={active ? onOpenRequest : undefined}
        onSelectCreatorJob={onSelectCreatorJob}
        onGeneratingChange={setGenerating}
      />
    </div>
  );
}
